jQuery(function($) {
	if (!$('.only_at_alohilani').length)
		return;
	$('.only_at_alohilani .slider_wrapper .slick-slide').eq(3).addClass('slide_lines');
	$('.only_at_alohilani .slide .slide_wrapper').on('focusin', function(){
		$(this).addClass('focusin')
	})
	$('.only_at_alohilani .slide .slide_wrapper').on('focusout', function(){
		$(this).removeClass('focusin')
	})
	$('.only_at_alohilani .slider_wrapper').on('init', function() {
		$('.only_at_alohilani .slick-slide:not(.slick-active)').find('.slide_wrapper, .overlay_content *:not(object)').attr('tabindex', -1);
	});

	$('.only_at_alohilani .slider_wrapper').on('init', function(event){
		$('.only_at_alohilani .slick-arrow').on('click', function() {
			setTimeout(function(){
				currentSlideEl = $('.only_at_alohilani .slider_wrapper .slick-current');
				currentSlideEl.focus();
			}, 300);
		});
	});

	// Starts videos playing to get around issue with DOM manipulation and video autoplay
	initializeSlick('.only_at_alohilani .slider_wrapper', {
		accessibility: true,
		dots: false,
		infinite: false,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 4,
		autoplay: false,
		arrows: true,
		nextArrow: '<button class="slider_arrow next_arrow" tabindex="0">Next</button>',
		prevArrow: '<button class="slider_arrow prev_arrow" tabindex="0">Previous</button>',
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 481,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
		]
	});
	$('.only_at_alohilani .slider_wrapper').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		$('.only_at_alohilani .slider_wrapper .slick-active').removeClass('slide_lines');
	});
	$('.only_at_alohilani .slider_wrapper').on('afterChange', function(event, slick, currentSlide, nextSlide){
		$('.only_at_alohilani .slider_wrapper .slick-active').eq(3).addClass('slide_lines');
		$('.only_at_alohilani .slick-slide').find('.slide_wrapper, .overlay_content *:not(object)').attr('tabindex', -1);
		$('.only_at_alohilani .slick-active').find('.slide_wrapper, .overlay_content *:not(object)').attr('tabindex', 0);
	});
});

